import { HttpParams } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NbActionComponent, NbDialogService } from '@nebular/theme';
import { OfbizEditDialogComponent } from './../ofbiz-edit-dialog.component';
import { Angular2SmartTableComponent, LocalDataSource } from 'angular2-smart-table';
import { OfbizFormsService } from './../ofbiz-forms.service';
import { ColumnFieldTitle, Pagination, RemoteFormData } from './../ofbiz-form-model';
import { OfbizListService } from './ofbiz-list.service';
import { Subject, Subscription } from 'rxjs';
import { ConfirmEditInfo, MultiSelectCheckBoxService } from './../ofbiz-check-box-editor/multi-select-check-box.service';
import { TableFactoryService } from './table-factory.service';
import { PaginationService } from './pagination/pagination.service';
import { map, take, takeUntil } from 'rxjs/operators';

/**
 * Component to display a list of items from the backend
 * It uses the ofbizFormService to retrieve the list from the backend
 * RemoteFormData is used to pass the form data to the backend
 * The getList() method is used to retrieve the list from the backend
 * The handleSuccess() method is used to handle the response from the backend
 * The createTable() method is used to create the table from the list
 * TableFactoryService is used to create the table settings
 * load source is used to load the data into the table
 * The source object is passed to the html template as input for angularSmartTable
 * The settings object is aldo passed to the html template as input for angularSmartTable
 */

@Component({
  selector: 'ubs-ofbiz-list',
  templateUrl: './ofbiz-list.component.html',
  styleUrls: ['./ofbiz-list.component.scss']
})
export class OfbizListComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  @Input() remoteFormData: RemoteFormData;
  @Input() fieldOptions: any; // key value properties to display descriptions insteadof ids
  @Input() columnFields: any; // fields needed to create table colums
  @Input() columnFieldTitles: ColumnFieldTitle[];
  // @Input() findFields:any[];//fields needed for display-entity cells
  @Input() listOptions: any;
  // @Input() ofbizList:any;
  @Input() title: string;
  @Input() state: any;
  @Input() searchResults: any;
  @Input() sideBarState: string;
  @Input() isLookup: boolean;
  @Input() cardMode: boolean;
  @Input() doRefreshList: boolean;
  ofbizList: any = {};
  open: boolean = false;
  isMulti: boolean = false;

  list: any[];

  paginate: boolean;
  paginateSubscription: Subscription;

  listSize: number;
  viewSize: number = 20;
  viewSizeOptions = [
    { value: 10, key: "10 per page" },
    { value: 20, key: "20 per page" },
    { value: 30, key: "30 per page" },
    { value: 40, key: "40 per page" },
    { value: 50, key: "50 per page" }
  ];
  selectedViewSize: any;

  /* readonly viewSize$ = this.paginationService.viewSize$.pipe().subscribe(viewSize => {
    if(this.viewSize != viewSize){
      this.remoteFormData.parameters["viewSize"] = viewSize;
      this.loaded = false;
      this.getList(this.remoteFormData);
    }
  }) */

  readonly pagination$ = this.paginationService.getPagination().subscribe(pagination => {
    if (pagination != null && pagination.event != "start") {
      this.handlePagination(pagination)
    }
  })



  searchFields: any[] = [];
  filter = false;

  formFields: any[];
  formData: any = {}; // Used to retrieve list from backend
  form: FormGroup;
  target: string;
  appContext: string;
  payLoad = '';

  idFieldName: string;
  hyperlinkSubscription: Subscription;

  settings: any = {};

  source: LocalDataSource = new LocalDataSource();
  loaded = false;
  hasLinkedList = false;

  private destroy$ = new Subject<void>();

  @ViewChild('search', { static: false }) search: ElementRef;

  @ViewChild('previousButton', { static: true }) previousButton: ElementRef;
  @ViewChild('nextButton', { read: NbActionComponent, static: false }) nextButton: ElementRef;
  @ViewChild('smartTable', { static: false }) smartTable: Angular2SmartTableComponent;

  @Output() linkSelected = new EventEmitter();
  @Output() overViewSelected = new EventEmitter();
  @Output() editSelected = new EventEmitter();
  @Output() hyperlinkSelected = new EventEmitter();
  @Output() listSuccessNotify = new EventEmitter();
  @Output() rowSelected = new EventEmitter();
  @Output() resultSize = new EventEmitter();

  readonly selectFirstRow$ = this.listSuccessNotify.pipe(
    map(data => data)
  )


  submitEnabled: boolean = false;

  constructor(
    private ofbizFormSerive: OfbizFormsService,
    private tableFactoryService: TableFactoryService,
    private paginationService: PaginationService,
    private ofbizListService: OfbizListService,
    private multiSelectCheckBoxService: MultiSelectCheckBoxService) {
    this.hyperlinkSubscription = this.ofbizListService.getHyperlinkCell()
      .pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        if (data != null) {
          console.log({ "emitting-hyperlink": data });
          const event = data["event"];
          switch (event) {
            case "list":
              this.hyperlinkSelected.emit(data);
              break;
            case "edit":
              console.log({ "TrackEdit": event, "component": "OfbizListComponent", "data": data });
              this.hyperlinkSelected.emit(data);
              break;
            case "delete":
              const hyperlink = data["data"];
              this.ofbizFormSerive.postFormData(this.ofbizListService.parametersToFormData(hyperlink["parameters"]), this.appContext, hyperlink["endPoint"], false)
                .subscribe(data => {
                  console.log(data);
                });
              break;
            case "add":
              console.log({ "addingThings": event });
              this.hyperlinkSelected.emit(data);
              break;
            case "link":
              console.log({ "linkingThings": data });
              this.hyperlinkSelected.emit(data);
              break;
            default:
              this.hyperlinkSelected.emit(data);
              break;
          }
        }


      });
  }

  handlePagination(pagination: Pagination) {
    const event = pagination.event;
    switch (event) {
      case "first":
        this.remoteFormData.parameters["viewIndex"] = 0;
        this.loaded = false;
        this.getList(this.remoteFormData);
        break;
      case "last":
        this.remoteFormData.parameters["viewIndex"] = pagination.viewIndex;
        this.loaded = false;
        this.getList(this.remoteFormData);
        break;
      case "next":
        this.remoteFormData.formData.viewIndex = pagination.viewIndex;
        this.remoteFormData.parameters["viewIndex"] = pagination.viewIndex;
        this.loaded = false;
        this.getList(this.remoteFormData);
        break;
      case "previous":
        this.remoteFormData.parameters["viewIndex"] = pagination.viewIndex;
        this.loaded = false;
        this.getList(this.remoteFormData);
        break;
      case "setViewSize":
        this.remoteFormData.parameters["viewSize"] = pagination.viewSize;
        this.remoteFormData.parameters["viewIndex"] = pagination.viewIndex;
        this.loaded = false;
        this.getList(this.remoteFormData);
        break;
      default:
        break;
    }
  }

  ngOnInit(): void {
    console.log({ "TrackListOptions": this.listOptions });
    // console.log("formData",this.formData);
    if (this.listOptions?.linkedList) {
      this.hasLinkedList = true;
    }
    if (this.listOptions?.idFieldName) {
      this.idFieldName = this.listOptions.idFieldName;
    }
    /**
     * This isn't used anywhere
     */
    this.selectFirstRow$.subscribe(data => {
      if (data != undefined && data != null) {
        if (data.rows != undefined && data.rows != null)
          console.log({ SelectFirstRow: data.rows[0] });
      }

    })


  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["remoteFormData"]) {
      console.log("Track RemoteFormData Change", this.remoteFormData);
      // console.log("OfbizListComponent remoteFormData",this.remoteFormData);
      if (this.remoteFormData != undefined) {
        if (this.remoteFormData.appContext) {
          this.appContext = this.remoteFormData.appContext;
        }
        // console.log({RemoteDataParameters:this.remoteFormData.parameters,remoteFormData:this.remoteFormData})
        this.paginationService.resetPaginagtion();
        this.getList(this.remoteFormData);
      }
      if (this.listOptions != undefined && this.listOptions != null) {
        if (this.listOptions?.idFieldName != undefined && this.listOptions.idFieldName != null) {
          this.idFieldName = this.listOptions.idFieldName;
        }
      }
    }
    if (changes["columnFieldTitles"]) {
      console.log({ columnFieldTitles: this.columnFieldTitles })
    }
    if (changes["listOptions"]) {
      // console.log({Listoptions:this.listOptions});
      if (this.listOptions?.idFieldName) {
        this.idFieldName = this.listOptions.idFieldName;
      }
      if (this.listOptions?.viewSize) {
        this.viewSize = this.listOptions.viewSize;
      }
    }
    if (changes["cardMode"]) {
      console.log({ CardMode: this.cardMode });
    }
    if (changes["searchResults"]) {
      if (this.searchResults) {
        this.createTable(this.searchResults);
        this.loaded = true;
      }
    }
    if (changes["doRefreshList"]) {
      console.log("Refreshing ..... ")
      console.log({ RefreshList: this.doRefreshList, Component: "OfbizListComponent", Comment: "On changes" });
      if (this.doRefreshList == true) {
        console.log({ TrackRefreshList: this.doRefreshList })
        this.refreshList()
      }

    }
  }
  /**
   * Get's list of items from remote server through ofbizFormService
   *
   * @param formData
   * @param endPoint
   */
  getList(remoteFormData: RemoteFormData): void {
    console.log({ RemoteFormData: remoteFormData })
    remoteFormData = this.addParameters(remoteFormData, this.fieldOptions);
    this.ofbizFormSerive.getList(remoteFormData)
      .subscribe((responseData: any) => {
        const statusCode = responseData["statusCode"];
        switch (statusCode) {
          case 200:
            if (responseData["successMessage"] == "OK") {
              const data = responseData["data"];
              const formData = data["formData"];
              if (data["responseMessage"] == "success") {
                this.handleSuccess(formData);
              }
            }
            break;
          case 404:

            break;
          case 500:

            break;
          default:
            break;
        }
      });
  }
  /**
   * Used to add parameters to the remoteFormData object
   * @param remoteFormData RemoteFormData object
   * @param fieldOptions array of fieldName and fieldValue objects to be used as parameters for the list
   * @returns RemoteFormData with paramaters
   */
  addParameters(remoteFormData: RemoteFormData, fieldOptions: any[]): RemoteFormData {
    console.log({ remoteFormDataParameters: remoteFormData.parameters });
    // console.log({fieldOptions:this.fieldOptions});
    let noConditionFind = {};
    if (this.fieldOptions != undefined) {
      noConditionFind = fieldOptions.find((field) => field.name == "noConditionFind");
    }
    const parameters = remoteFormData["parameters"];
    if (parameters === undefined) {
      const parameters = {};
      if (noConditionFind) {
        // console.log("adding parameters .........");
        parameters["noConditionFind"] = "Y";
        /* let index = this.ofbizList['fields'].indexOf(noConditionFind);
        this.ofbizList['fields'].fill(noConditionFind.value="Y", index, index++) */
      }
      remoteFormData["parameters"] = parameters;
    } else {
      console.log({ remoteFormData: remoteFormData });
      if (noConditionFind) {
        // console.log("adding parameters .........");
        // parameters["noConditionFind"] = "Y";
        remoteFormData["parameters"]["noConditionFind"] = "Y";
      }
    }
    // console.log(parameters);

    // remoteFormData["parameters"] = parameters;
    return remoteFormData;
  }
  /**
   *
   * @param formData any - Data from backend includind listSize, viewIndex, viewSize
   */
  handleSuccess(formData) {
    console.log({ Action: "handleSuccess", TrackColumnFields: this.columnFields });
    this.listSize = +formData["listSize"];
    const viewIndex = +formData["viewIndex"];
    this.viewSize = +formData["viewSize"];
    console.log({ FormData: formData });
    if (this.listSize > 0) {
      if (formData.listType != undefined && formData.listType == "multi") {
        this.isMulti = true;
      }
      const currentListSize: number = formData["rows"].length;
      // Rows to entries
      const rowEntries = this.convertRowsToRowEntries(formData["rows"]);
      console.log({ rowEntries: rowEntries });
      if (this.listSize < 21) {
        this.filter = false;
      }
      this.setPagination(this.listSize, viewIndex, this.viewSize, currentListSize);
      this.list = rowEntries;
      // console.log({list:this.list});
      if (this.isMulti) {
        console.log("It's multi");
        setTimeout(() => {
          this.createTable(this.list);
        }, 600);
      } else {
        this.createTable(this.list);
      }
      this.paginationService.getPagination().subscribe((pagination: Pagination) => {
        this.paginate = pagination ? pagination.paginate : null;
      });
      this.loaded = true;
      // emit remoteFormData for this list to notify external components
      this.notifySuccess(formData);
      // console.log({formData:formData});
    } else {
      this.notifySuccess(this.remoteFormData);
      this.settings["actions"] = false;
      this.loaded = false;
      this.settings.noDataMessage = "No data found for query: " + JSON.stringify(formData["queryStringMap"]);
      this.source.load([]);
      this.source.refresh();
      // console.log({settings:this.settings});
      this.loaded = true;
    }
  }/**
  *
  * @param rows Rows containing data to be converted into row  entries
  * @returns An array of row entries
  */
  convertRowsToRowEntries(rows: any[]): any[] {
    const rowEntries = [];
    rows.forEach((row: any[]) => {
      console.log({ rowBefore: row });
      const entries = {};
      const parameterMaps = [];
      row.forEach(element => {
        for (const [key, value] of Object.entries(element)) {
          if (key != "parameterMap") {
            if (this.isMulti) {
              /**
               * @comment
               * Strip keys of rowCounts
               */
              const _key = key.replace(/_.*/, "");
              entries[_key] = value;
            } else {
              entries[key] = value;
            }
          }
        }
        if (element["parameterMap"]) {
          const parameterMap = { fieldName: Object.keys(element)[0], parameterMap: element["parameterMap"] };
          console.log({ FieldParameterMap: { fieldName: Object.keys(element)[0], rowElementParameterMap: element["parameterMap"] } });
          parameterMaps.push(parameterMap);
        } else {
          console.log("No parameterMap for entry :" + element);
        }
        // const entry = JSON.parse(JSON.stringify(element));
        // Object.assign(entries,entry);
        // entries = {...entries,entry}
        // entries[i] = element;
        if (parameterMaps.length > 0) {
          entries["parameterMaps"] = parameterMaps;
        }

      });
      console.log({ rowAfter: entries });
      if (this.isMulti) {
        entries["checkbox"] = false;
      }
      rowEntries.push(entries);
    })
    return rowEntries;
    // return rows;
  }
  /**
   *
   * @param list row entries consisting of key/value pairs
   * Use the tablefactory service to create the table settings;
   * Load and refresh the source
   */
  createTable(list: any[]): void {
    const newSettings = this.tableFactoryService.createTable(this.columnFields, this.fieldOptions, this.listOptions, this.isLookup, this.isMulti);
    if (newSettings) {
      this.settings = { ...newSettings };
      // this.settings = this.tableFactoryService.createTable(this.columnFields,this.fieldOptions,this.listOptions,this.isLookup,this.isMulti)
      // this.source.load(list);
      if (this.isMulti) {
        this.source.getAll().then(result => {
          console.log({ SourceElements: result })
        })
      }
      setTimeout(() => {
        this.source.load(list);
        this.source.refresh();
      });
    }

  }

  /**
   *
   * @remarks
   * This method sets various fields used for paginating the list
   * @param listSize - the size of the list
   * @param viewIndex - the current viewIndex
   */
  setPagination(listSize: number, viewIndex: number, viewSize: number, currentListSize: number): void {
    /*this.selectedViewSize = this.viewSizeOptions.find(viewSizeOption => viewSizeOption.value == viewSize);
    console.log({SelectedViewSize:this.selectedViewSize}); */
    this.paginationService.setPagination(listSize, viewIndex, viewSize, currentListSize);
  }


  ngAfterViewInit(): void {
    // Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    // Add 'implements AfterViewInit' to the class.
    // this.nextButton.nativeElement.disabled = true;
  }

  setSearchFields(fields: any[]) {
    fields.forEach(field => {
      if (field.name.includes("Id") || field.name.includes("Description") || field.name.includes("Name")) {
        this.searchFields.push(field.name);
      }
    });
    // console.log(this.searchFields);
  }
  setNoConditionFind() {
    const noConditionFind = this.ofbizList['fields'].find((field) => field.name == "noConditionFind")
    if (noConditionFind) {
      let index = this.ofbizList['fields'].indexOf(noConditionFind);
      this.ofbizList['fields'].fill(noConditionFind.value = "Y", index, index++)
    }
  }

  addOptionalFields() {
    const textFields = this.ofbizList['fields'].filter((field) => field.type === "text");
    textFields.forEach((textField) => {
      const _icname = textField.name + "_ic";
      const _opname = textField.name + "_op";
      const _icfieldToAdd = { "name": _icname, "value": "Y" };
      const _opFieldToAdd = { "name": _opname, "value": "contains" };
      this.ofbizList['fields'].push(_icfieldToAdd);
      this.ofbizList['fields'].push(_opFieldToAdd);
      //
    })
  }

  populateFormData() {
    // console.log("Populating formData");
    this.ofbizList['fields'].forEach(field => {
      if (field.value) {
        // console.log({"name":field.name,"value":field.value});
        this.formData[field.name] = field.value;
      }
    });
    this.formData["formName"] = this.listOptions.formName;
    this.formData["formLocation"] = this.listOptions.formLocation;
    this.formData["entityName"] = this.listOptions.entityName;
    this.formData["viewIndex"] = this.listOptions.viewIndex;
  }

  onSearch(query: string = '') {
    if (query === '') {
      // this.source.reset();
      this.source.setFilter([])
    } else {
      // console.log(query);
      const searchFields: any[] = this.getSearchFields(query);
      // console.log(searchFields);
      this.source.setFilter(searchFields, false)
    }
  }

  getSearchFields(query: string) {
    const conf = [];
    this.searchFields.forEach(searchField => {
      const confField = { "field": searchField, "search": query };
      conf.push(confField);
    });
    return conf;
  }

  toggleFilter(query: string) {
    if (this.filter) {
      this.onSearch(query);
    } else {
      this.source.reset();
      this.search.nativeElement.value = '';
    }
    this.filter = !this.filter;
  }

  editRow(event) {
    console.log({ EditRow: this.settings.mode });
    let container: string = "main";
    if (this.settings.mode = "external") {
      container = "dialog";
      const context = {
        title: 'Edit ' + this.state.componentConfig.title,
        container: container,
        action: "edit",
        // data: {"state":this.state,"data":event["data"]},
        data: event["data"],
        fieldList: this.columnFields
      }
      // console.log({TrackEditRow:{"component":"ofbizListComponent","value":{context}}});
      this.editSelected.emit(context);
    }

  }

  deleteRow(event) {
    console.log({ "event": event });
  }

  onCustom(event) {
    // console.log({Custom:event["data"]});
    // this.settings = {};
    const customData = event["data"];
    const action = event["action"];
    switch (action) {
      case "linkedList":
        this.showLinkedList(customData);
        break;
      case "overView":
        this.showOverview(customData);
        break;
      default:
        break;
    }

  }

  confirmCreate(event) {
    console.log({ ConfirmCreate: event });
  }

  confirmDelete(event) {
    console.log({ ConfirmDelete: event });
  }
  showLinkedList(customData: any) {
    const masterLinkField = this.listOptions.linkedList.masterLinkField;
    const detailParameterField = this.listOptions.linkedList.detailParameterField;

    if (masterLinkField && detailParameterField) {
      // console.log(customData[this.idFieldName]);
      // console.log(this.listOptions.linkedList);
      const formData: any = {};
      let fields: any[];
      let ofbizForm: any = {};
      if (this.listOptions.linkedList.local) {
        // console.log("It's local");
        fields = this.listOptions.linkedList.fieldFormFields;
        ofbizForm["fields"] = fields;
      } else {
        const formOptions = {
          "formName": this.listOptions.linkedList.fieldFormName,
          "formLocation": this.listOptions.linkedList.fieldFormLocation,
          "entityName": this.listOptions.linkedList.entityName,
        }
        this.ofbizFormSerive.getForm(formOptions)
          .subscribe(data => {
            ofbizForm = data;
            const fields: any[] = data["fields"];
            this.ofbizList["fields"] = fields;
          })
      }
      fields.forEach(field => {
        if (field.name == this.idFieldName) {
          // console.log({fieldName:field.name,idFieldName:this.idFieldName});
          formData[field.name] = customData[this.idFieldName];
        } else if (field.name == detailParameterField) {
          formData[field.name] = customData[masterLinkField]
        } else if (field.name == "noConditionFind") {
          formData[field.name] = "Y";
        } else {
          formData[field.name] = field.value;
        }
      });
      formData["formName"] = this.listOptions.linkedList.listFormName;
      formData["formLocation"] = this.listOptions.linkedList.listFormLocation;
      formData["entityName"] = this.listOptions.linkedList.entityName;
      formData["viewIndex"] = this.listOptions.linkedList.viewIndex;
      const remoteFormData: RemoteFormData = { formData: formData, endPoint: "", parameters: {} }
      // this.linkedListActive = true;
      this.ofbizFormSerive.getList(remoteFormData)
        .subscribe((data: any) => {
          console.log({ linkedListData: data });
          this.linkSelected.emit({ selectedValue: customData, idField: this.idFieldName, ofbizForm: ofbizForm, result: data, listForm: this.listOptions.linkedList });
        });
    }
  }
  onOverview(e) {
    console.log(e);
  }

  showOverview(customData: any) {
    console.log("Overview selected");
    this.overViewSelected.emit(customData);
    console.log(customData);
  }


  createFormData(data) {
    // fieldInfo & rowData
    console.log(data);
    const field = data.field;
    console.log(field);
    this.hyperlinkSelected.emit(data)
  }

  onEdit(e) {
    console.log({ OnEdit: e });
  }

  notifySuccess(remoteFormData: RemoteFormData): void {
    this.listSuccessNotify.emit(remoteFormData);
  }

  ngOnDestroy(): void {
    // this.hyperlinkSubscription.unsubscribe();
    // this.paginateSubscription.unsubscribe()
    this.destroy$.next();
    this.destroy$.complete()
  }

  refreshList() {
    console.log({ RefreshList: this.doRefreshList, Component: "OfbizListComponent", Comment: "Executing RefreshList method" });
    this.getList(this.remoteFormData);
  }
  /**
   * Takes data from the editConfirm() function of angular2-smart-table.
   * Use (convertFormValueToFormData) to create formData which is then submitted to backend.
   * It also refreshes the edited list
   * @param data from the row consisting of -
   * original row data
  *        newData: Object - edited data
   *       source: DataSource - table data source
   *       confirm: Deferred - Deferred object with resolve(newData: Object) and reject() methods.ata: Object - original row data
   *
   */
  confirmEdit(data): void {
    if (this.isMulti) {
      const sourceData: any[] = data["source"]["data"];
      const rowData: any = data["data"];
      console.log({ SourceData: data["source"], rowData: rowData });
      if (this.idFieldName) {
        console.log({ idFieldName: this.idFieldName });
        const idFieldValue = rowData[this.idFieldName];
        // this.multiSelectCheckBoxService.setConfirmEditData(data,rowIndex);
        const isSame = this.multiSelectCheckBoxService.checkIsSame(data);
        console.log({ isSame: isSame });
        if (isSame) {
          data.confirm.resolve();
        } else {
          data.newData["checkbox"] = true;
          data.confirm.resolve(data.newData);
          this.source.onUpdated().subscribe(event => {
            console.log({ onUpdated: event })
            if (event != null && event != undefined) {
              this.submitEnabled = true;
            }
          });
        }
      }

    } else {
      console.log({ TrackEditConfirm: data, columnFields: this.columnFields });
      const target = this.listOptions.target || this.listOptions.addForm.targets.updateTarget;
      const fields: any[] = [];
      this.listOptions.addForm.fields.forEach(element => {
        const field = { name: "", type: "" };
        field.name = element.name;
        const column = this.columnFields.find(column => column.name == element.name);
        field.type = column.type;
        fields.push(field);
      });
      const formData: FormData = this.convertFormValueToFormData(data.newData, fields);
      this.ofbizFormSerive.postFormData(formData, this.appContext, target, false)
        .subscribe(data => {
          console.log(data)
          this.getList(this.remoteFormData);
        });
    }

  }

  /**
   * Converts row data to formData ready for posting
   * @param newValue The row data with values updated by editing editable cells
   * @param fields fields from the addForm which will be used in creating the formData object
   * @returns FormData with values which will be submitted to the backend
   */
  convertFormValueToFormData(newValue: any, fields: any[]): FormData {
    console.log({ TrackEditConfirm: { newValue: newValue, fields: fields } });
    const formData = new FormData();
    Object.entries(newValue).forEach(([key, value]) => {
      const field = fields.find(field => field.name == key);
      if (field != undefined) {
        if (field.type != "HYPERLINK" && field.type != "hyperlink" && field.type != "DISPLAY" && field.type != "display" && field.type != "DISPLAY_ENTITY" && field.type != "display-entity") {
          formData.append(key, <string><any>value);
        } else if (newValue["parameterMaps"] != undefined) {
          console.log({ TrackEditConfirm: newValue["parameterMaps"] })
          const parameterMapEntry = newValue["parameterMaps"].find(obj => {
            return obj.fieldName === "deleteLink" || obj.fieldName === "updateLink"
          })
          if (parameterMapEntry) {
            console.log({ TrackEditConfirm: parameterMapEntry })
            const parameterMap: any = parameterMapEntry["parameterMap"];
            if (parameterMap) {
              for (const [k, v] of Object.entries(parameterMap)) {
                if (k == key) {
                  formData.append(key, <string><any>v);
                }
              }
            }
          }
        }
      } else {
        console.log({ TrackEditConfirm: { NotFounf: key } });
      }

    });
    return formData
  }

  onUserRowSelect(e) {
    console.log({ rowSelected: e });
    this.rowSelected.emit(e);
    this.hyperlinkSelected.emit(e);
  }

  onSubmitMuliSelect(e) {
    console.log({ SourceData: this.source["data"] });
    const formData = this.convertSourceToFormData(this.source["data"]);
    const target = this.listOptions.target;
    this.ofbizFormSerive.postFormData(formData, this.appContext, target, false)
      .subscribe(data => {
        console.log(data)
        this.getList(this.remoteFormData);
      });
  }

  convertSourceToFormData(data: any[]): FormData {
    const formData = new FormData();
    const unchecked = data.filter(row => row.checkbox == false);
    if (unchecked.length == 0) {
      formData.append("selectAll", "Y");
    }
    formData.append("_useRowSubmit", "Y");
    formData.append("_checkGlobalScope", "N");
    data.forEach((row, index) => {
      if (row.hasOwnProperty("parameterMaps", "N")) {
        delete row.parameterMaps;
      }
      if (row.hasOwnProperty("checkbox") && row["checkbox"] == false) {
        delete row.checkbox;
      }
      const postfix: string = "_o_" + index;
      for (let [k, v] of Object.entries(row)) {
        let formKey = "";
        if (k == "checkbox" && v == true) {
          formKey = "_rowSubmit" + postfix;
          v = "Y"
        } else if (k != "checkbox") {
          formKey = k + postfix;
        }
        formData.append(formKey, <any>v);
      }
    });
    formData.append("_rowCount", <string><any>data.length)

    return formData
  }

  showFilter(e) {
    console.log(e)
    this.filter = true;
  }

  hideFilter() {
    this.filter = false;
  }



}
